<div class=" flex column-gap-2 col-12 card justify-content-start align-items-center">
  <input
    class="sizefilter"
    type="search"
    pInputText
    placeholder="{{'Search_Lab' | translate}}"
    [(ngModel)]="filterName"
    (keyup)="filter($event.target.value)"
    />
    <p-button styleClass="p-button-outlined" icon="text-xl icons8-rouleau---peinture" pTooltip="{{'Color' | translate}}" (click)="onClickColor()"></p-button>
    <p-button styleClass="p-button-outlined" icon="text-xl icons8-palette-de-peinture" pTooltip="{{'Color_Init' | translate}}" (click)="confirmInitialize()"></p-button>

  </div>
  <div class="card flex flex-row container-height-with-top overflow-auto justify-content-evenly flex-wrap md:flex-row column-gap-1 gap-3">
    @for (bsk of basketAll; track bsk) {
      <div
          [ngClass]="{
          'select': bsk.Information.isSelected === true
          }"
          [id]="bsk.Information.color" (click)="onSelBasket($event,bsk)" style="cursor: pointer;">
        <basket-param
          [bsk]="bsk"
          [compactMode]="internalPrefUsr.bskCompact"
          >
        </basket-param>
      </div>
    }
  </div>

  <p-dialog
    [contentStyle]="{ overflow: 'visible', 'max-height': '60vh', 'max-width': '55vw'}"
    [style]="{ width: '15vw'}"
    [(visible)]="displayColor"
    [resizable]="false"
    [modal]="true"
    [closable]="true"
    (onHide)="closeColor()"
    >
    <ng-template pTemplate="header">
      <span class="p-dialog-title">
        {{'Color_Ch' | translate}}
      </span>
    </ng-template>
    <p-colorPicker [(ngModel)]="currentColor" [inline]="true"></p-colorPicker>
    <input class="mt-1" type="text" pInputText [(ngModel)]="currentColor" />

    <div class="col-12 md:col-12 align-right">
      <button class="p-button-primary p-button-outlined mr-1" type="button" pButton (click)="closeColor()" label="{{'Cancel' | translate}}"></button>
      <button type="button" pButton class="margin" (click)="saveColor()" label="{{'Apply' | translate}}"></button>
    </div>
  </p-dialog>

  <app-item-confirm
    [key]="'delete'"
    [severity]="'alert'"
    (onAccept)="confirmInitialize()"
  ></app-item-confirm>

